module.exports = __webpack_public_path__ + "img/pm_13.aeb3bda1.png";